const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '不缓冲秒开',
    desc: '智能预加载引擎提前缓存下一片段，点击播放按钮即刻呈现画面，告别旋转的加载图标。全网领先的零延迟播放技术，让每一次观影都流畅到底。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '全片源支持1080P至4K超清分辨率，自适应的码率调节确保不同网络环境下都能获得最佳画质。暗部细节和色彩还原达到专业级水准。',
  },
  {
    id: 3,
    icon: 'ri-speed-up-line',
    title: '高速加载',
    desc: '全球CDN加速节点覆盖，智能路由选择最优线路。即便在网络波动环境下，也能维持稳定的高速传输，保障高清影片无卡顿连续播放。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '桌面端、平板、手机全设备自适应。观影进度云端同步，电脑看到一半出门用手机接着看，丝滑切换无需重头播放。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            极致体验
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            四项核心技术让免费在线看电影成为一种享受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="bg-background-100/80 rounded-lg p-5 md:p-6 border border-background-200/50 hover:border-primary-500/20 transition-all duration-200 group text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/15 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-200 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}